module.exports = __webpack_public_path__ + "static/media/favicon.269811b4.png";